import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import '../../pages/BirthdaysPage.css';

/**
 * Sport dashboard: a small "Birthdays today" strip linking to /birthdays.
 * Renders nothing when nobody has a birthday today (or the call fails).
 */
export default function BirthdaysTodayChip() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [today, setToday] = useState([]);

  useEffect(() => {
    let alive = true;
    api.get('/birthday-gifts/birthdays', { params: { days: 1 } })
      .then((r) => { if (alive) setToday(Array.isArray(r?.today) ? r.today : []); })
      .catch(() => { if (alive) setToday([]); });
    return () => { alive = false; };
  }, []);

  if (!today.length) return null;
  const names = today.map((p) => p.firstName || p.name).filter(Boolean).join(', ');

  return (
    <button type="button" className="bd-dash-chip" onClick={() => navigate('/birthdays')} data-testid="birthdays-today-chip">
      <span className="bd-dash-chip__emoji" aria-hidden="true">🎂</span>
      <span className="bd-dash-chip__text">
        <strong>{t('birthdays.chip.title', { count: today.length })}</strong>
        <small>{names}</small>
      </span>
      <span className="bd-dash-chip__cta">{t('birthdays.chip.cta')}</span>
    </button>
  );
}
